import { CrudEndpoint } from '@/api/common/CrudEndpoint';
import { FontDTO } from '@/api/dto/FontDTO';

export class FontCRUD extends CrudEndpoint<FontDTO> {
  constructor() {
    super('font');
  }
}
